export default __webpack_public_path__ + "static/media/toneel-480.ee73d442.jpg";